import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
    background-color: ${props => props.theme.colors.secondary};
    color: ${props => props.theme.colors.text};
    line-height: 1.6;
    overflow-x: hidden;
    font-weight: 400;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Inter', sans-serif;
    font-weight: 600;
    line-height: 1.2;
    margin-bottom: ${props => props.theme.spacing.sm};
  }

  h1 {
    font-size: 3rem;
    font-weight: 700;
  }

  h2 {
    font-size: 2.5rem;
  }

  h3 {
    font-size: 2rem;
  }

  h4 {
    font-size: 1.5rem;
  }

  p {
    margin-bottom: ${props => props.theme.spacing.sm};
    color: ${props => props.theme.colors.textLight};
  }

  a {
    color: ${props => props.theme.colors.accent};
    text-decoration: none;
    transition: ${props => props.theme.transitions.fast};
  }

  a:hover {
    opacity: 0.8;
  }

  button {
    font-family: inherit;
    cursor: pointer;
    border: none;
    outline: none;
    transition: ${props => props.theme.transitions.fast};
  }

  input, textarea {
    font-family: inherit;
    outline: none;
    border: 1px solid #ddd;
    transition: ${props => props.theme.transitions.fast};
  }

  input:focus, textarea:focus {
    border-color: ${props => props.theme.colors.accent};
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 ${props => props.theme.spacing.md};

    @media (max-width: ${props => props.theme.breakpoints.mobile}) {
      padding: 0 ${props => props.theme.spacing.sm};
    }
  }

  .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 14px 28px;
    border-radius: 8px;
    font-weight: 600;
    font-size: 0.95rem;
    text-align: center;
    transition: ${props => props.theme.transitions.fast};
    cursor: pointer;
    border: none;
    text-decoration: none;
    gap: 8px;
    position: relative;
    overflow: hidden;
    letter-spacing: -0.01em;
  }

  .btn-primary {
    background-color: ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.secondary};
  }

  .btn-primary:hover {
    background-color: #262626;
    transform: translateY(-1px);
  }

  .btn-secondary {
    background-color: transparent;
    color: ${props => props.theme.colors.primary};
    border: 1px solid ${props => props.theme.colors.border};
  }

  .btn-secondary:hover {
    background-color: ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.secondary};
    border-color: ${props => props.theme.colors.primary};
    transform: translateY(-1px);
  }

  .btn-accent {
    background-color: ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.secondary};
  }

  .btn-accent:hover {
    background-color: #262626;
    transform: translateY(-1px);
  }

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    h1 {
      font-size: 2.5rem;
    }
    
    h2 {
      font-size: 2rem;
    }
    
    h3 {
      font-size: 1.5rem;
    }
  }
`;

export default GlobalStyles;
